import ChartRepository from "../domain/data/ChartRepository";
import { CampaignChart } from "../domain/entities/Chart";
import User from "../domain/entities/User";
import AwsApiClient from "../presentation/hooks/AwsApiClient";

export default class APICharteRepository implements ChartRepository {
  private client = new AwsApiClient();

  async getCampaignChart(user: User): Promise<CampaignChart[]> {
    try {
      const response = await this.client.get(
        `/api/events/getcounts`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
}
